/** Arabic for the shell: start-up, header, sidebar, banners, the screen strip and the summary view. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  // start-up
  "Connecting…": "جارٍ الاتصال…",
  "Sky Logics · operations control": "سكاي لوجيكس · مركز التحكم بالعمليات",
  "Could not start": "تعذّر بدء التشغيل",
  "Check VITE_SLT_API_URL and the credential in .env.local, or set VITE_DATA_SOURCE=mock to run on the built-in sample.":
    "تحقّق من VITE_SLT_API_URL ومن بيانات الاعتماد في .env.local، أو اضبط VITE_DATA_SOURCE=mock للعمل على البيانات التجريبية المضمّنة.",
  "Try again": "إعادة المحاولة",
  Loading: "جارٍ التحميل",

  // header and sidebar
  "Customize menu": "تخصيص القائمة",
  "Data:": "البيانات:",
  "Watching the platform's change feed every ten seconds; whatever is on screen refreshes when something changes":
    "تُراقَب تغييرات المنصة كل عشر ثوانٍ، ويتحدّث ما على الشاشة عند حدوث أي تغيير",
  "Not watching for changes: {reason}": "لا تُراقَب التغييرات: {reason}",
  unknown: "غير معروف",
  live: "مباشر",
  "not live": "غير مباشر",
  Site: "الموقع",
  "Local time": "التوقيت المحلي",
  "The platform is accepting development authentication headers": "المنصة تقبل ترويسات مصادقة التطوير",
  Notifications: "الإشعارات",
  "{n} unread notification|{n} unread notifications":
    "لا توجد إشعارات غير مقروءة|إشعار واحد غير مقروء|إشعاران غير مقروءين|{n} إشعارات غير مقروءة|{n} إشعارًا غير مقروء|{n} إشعار غير مقروء",
  "Switch to light theme": "التبديل إلى المظهر النهاري",
  "Switch to dark theme": "التبديل إلى المظهر الداكن",
  Theme: "المظهر",
  "Sign out": "تسجيل الخروج",
  "Fold this suite away": "طيّ هذه المجموعة",
  "Open this suite": "فتح هذه المجموعة",
  "About {name}": "عن {name}",
  "Hide what this suite does": "إخفاء وصف هذه المجموعة",

  // banners
  "SAMPLE DATA": "بيانات تجريبية",
  "The platform could not be reached, so this session is showing the built-in sample. Reason:":
    "تعذّر الوصول إلى المنصة، لذا تعرض هذه الجلسة البيانات التجريبية المضمّنة. السبب:",
  "No platform configured — set VITE_SLT_API_URL to connect. Nothing shown here is real.":
    "لم تُضبط أي منصة — اضبط VITE_SLT_API_URL للاتصال. لا شيء مما يُعرض هنا حقيقي.",

  // the strip above each screen
  "What does this screen do?": "ما وظيفة هذه الشاشة؟",
  "About this screen": "عن هذه الشاشة",
  Less: "أقل",
  "About this suite": "عن هذه المجموعة",
  "Hide these descriptions": "إخفاء هذه الأوصاف",
  Hide: "إخفاء",
  "A suite you arranged. Its screens:": "مجموعة رتّبتها بنفسك. شاشاتها:",

  // the summary view
  "Back to the summary": "العودة إلى الملخّص",
  "At a glance": "نظرة سريعة",
  "Ask Sky": "اسأل سكاي",
  "Open the full desk": "فتح المكتب كاملًا",
  "Always open desks in full": "فتح المكاتب كاملة دائمًا",

  // settings · appearance
  Appearance: "المظهر العام",
  "kept in this browser": "محفوظ في هذا المتصفح",
  Language: "اللغة",
  English: "English",
  العربية: "العربية",
  Dark: "داكن",
  Daylight: "نهاري",
  "Arabic lays the screens out right to left. Figures keep Western digits and the Gregorian calendar, and maps and drawings are not mirrored — north stays where it is. Text a screen computes itself is translated screen by screen, so some may still read in English.":
    "تعرض العربية الشاشات من اليمين إلى اليسار. تبقى الأرقام بالصيغة الغربية والتاريخ بالتقويم الميلادي، ولا تُعكس الخرائط والمخططات — يبقى الشمال في مكانه. يُترجَم النص الذي تحسبه كل شاشة بنفسها شاشةً بعد شاشة، لذا قد يظهر بعضه بالإنجليزية بعد.",
  "Signed out after 30 minutes without activity. Sign in again to carry on.":
    "سُجّل خروجك بعد 30 دقيقة دون نشاط. سجّل الدخول مجدداً للمتابعة.",

  /* what the platform said about a record a board entered */
  SAVED: "حُفظ",
  "NOT SAVED": "لم يُحفظ",
  "{ref} saved on the platform.": "حُفظ {ref} على المنصة.",
  "Not saved on the platform: {why}": "لم يُحفظ على المنصة: {why}",
  "Not permitted: your role does not hold {p}.": "غير مسموح: دورك لا يملك الصلاحية {p}.",
};
export default ar;
